import { ReportStudioPageMetadata } from '@/modules/ta/reportstudio/models/ReportStudioPageMetadata';
import { ReportStudioPageDesignOptionFactory } from '@/modules/ta/reportstudio/factories/ReportStudioPageDesignOptionFactory';

export class ReportStudioPageMetadataFactory {
  /**
   * @returns {ReportStudioPageMetadata}
   */
  static buildDefault() {
    return new ReportStudioPageMetadata({
      design_options: ReportStudioPageDesignOptionFactory.buildDefaultPageDesignOptions(),
    });
  }
}
